import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

import Clickable from '@prisjakt/ui-clickable';
import { Tooltip } from 'src/components/tooltip-new';
import ThumbsUpIconComponent from 'mdi-react/ThumbsUpIcon';
import { IconFlagOutlined, IconEye } from '@prisjakt/ui/icon';
import { TextButton } from '@prisjakt/ui/button/variants';

export const USER_AVATAR_SIZE = 32;
export const ANON_USER_AVATAR_SIZE = 24;

export const User = styled.div``;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
`;

export const UserReviewCard = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  grid-template-rows: auto auto;
  row-gap: ${layout.measurements.spacing050};

  &:not(:last-of-type) {
    border-bottom: 1px solid ${p => p.theme.lines.primary};
    padding-bottom: ${layout.measurements.spacing050};
  }

  ${User} {
    grid-area: 1 / 2 / 2 / 3;

    ${media.mediumDown`
      grid-area: 1 / 1 / 2 / 4;
    `};
  }

  ${Main} {
    grid-area: 2 / 2 / 3 / 3;

    ${media.mediumDown`
      grid-area: 2 / 1 / 3 / 4;
    `};
  }
`;

export const UserAvatar = styled(Clickable)``;

export const UserDisplayName = styled.span`
  max-width: 156px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 600;
`;

export const UserReviewCount = styled.span`
  font-size: ${layout.measurements.fontSizeSmall};
`;

export const UserInfo = styled.div`
  display: grid;
  grid-template-columns: ${USER_AVATAR_SIZE}px 1fr;
  grid-template-rows: auto auto;
  column-gap: ${layout.measurements.spacing050};
  color: ${p => p.theme.text.secondary};

  p {
    margin: 0;
  }

  a {
    &:hover {
      color: ${p => p.theme.text.callToActionHover};
    }
  }

  ${UserAvatar} {
    grid-area: 1 / 1 / 3 / 2;
    align-self: center;
  }

  ${UserDisplayName} {
    grid-area: 1 / 2 / 2 / 3;
  }

  ${UserReviewCount} {
    grid-area: 2 / 2 / 3 / 3;
  }
`;

export const AnonymousUser = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const AnonymousUserAvatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${p => p.theme.icons.quaternary};
  border-radius: 24px;
  height: ${ANON_USER_AVATAR_SIZE}px;
  width: ${ANON_USER_AVATAR_SIZE}px;

  svg {
    fill: ${p => p.theme.icons.secondary};
  }
`;

export const AnonymousUserDisplayName = styled.div`
  font-size: ${layout.measurements.fontSizeSmall};
  margin-left: ${layout.measurements.spacing050};
`;

export const Review = styled.div``;

export const Dates = styled.div`
  color: ${p => p.theme.text.tertiary};
  font-size: ${layout.measurements.fontSizeSmall};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const ViaShop = styled.div`
  color: ${p => p.theme.colors.maybeBlue700};
  font-size: ${layout.measurements.fontSizeSmall};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`;

export const ViaShopTooltip = styled(Tooltip)`
  display: flex;
`;

export const ViaShopText = styled.span`
  margin-left: ${layout.measurements.spacing025};
`;

export const CreateDate = styled.div``;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: ${layout.measurements.spacing050};
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${layout.measurements.spacing050};
`;

export const ThumbsUpIcon = styled(ThumbsUpIconComponent)`
  fill: ${p => p.theme.text.primary};
`;

export const EyeIcon = styled(IconEye)`
  fill: ${p => p.theme.text.primary};
`;

export const Statistic = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  position: relative;
  font-weight: 600;

  &:not(:last-of-type) {
    margin-right: ${layout.measurements.spacing050};
  }

  ${ThumbsUpIcon}, ${EyeIcon} {
    margin-right: ${layout.measurements.spacing025};
  }
`;

export const FlagIcon = styled(IconFlagOutlined)``;

export const ReportButton = styled(TextButton)`
  margin-left: auto;
`;

export const Edit = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
`;

export const Divider = styled.span`
  margin-left: ${layout.measurements.spacing050};
  margin-right: ${layout.measurements.spacing050};
  font-size: ${layout.measurements.fontSizeSmall};
  font-style: normal;

  &::after {
    color: ${p => p.theme.text.quaternary};
    content: '|';
  }
`;
